import { createThunkEffect } from "../../utilities/ActionUtility";
import * as FilesInfoEffect from "./FilesInfoEffect";

export const REQUEST_FILES_INFO = "FilesInfoEffect.REQUEST_FILES_INFO";
export const REQUEST_FILES_INFO_FINISHED = "FilesInfoEffect.REQUEST_FILES_INFO_FINISHED";

export function requestFilesInfo(product, from, to) {
    return async (dispatch) => {
        await createThunkEffect(dispatch, REQUEST_FILES_INFO, FilesInfoEffect.requestFilesInfo, product, from, to);
    };
}
